/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../api/common';
import '../../portal/service';
import '../common/create_async_transaction_refund';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "AsyncTransaction": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failedAtMs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": "squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": "squareup.esperanto.api.Merchant",
                    "id": 7,
                    "rule": "optional"
                  },
                  "merchantLegalName": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.esperanto.model.AsyncTransaction.AsyncTransactionStatus",
                    "id": 8,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.esperanto.model.AsyncTransaction.AsyncTransactionType",
                    "id": 9,
                    "rule": "optional"
                  },
                  "syncFailureType": {
                    "type": "squareup.portal.service.SubmitPortalTransactionError.SubmitPortalTransactionErrorType",
                    "id": 13,
                    "rule": "optional"
                  },
                  "failureMessage": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  },
                  "asyncTransactionRefund": {
                    "type": "squareup.esperanto.model.AsyncTransactionRefund",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "openBankingDetails": {
                    "type": "squareup.esperanto.model.AsyncTransactionOpenBankingDetails",
                    "id": 12
                  }
                },
                "nested": {
                  "AsyncTransactionStatus": {
                    "values": {
                      "DO_NOT_USE_STATUS": 0,
                      "CREATED": 1,
                      "PENDING": 2,
                      "COMPLETED": 3,
                      "FAILED": 4
                    }
                  },
                  "AsyncTransactionType": {
                    "values": {
                      "DO_NOT_USE_TYPE": 0,
                      "OPEN_BANKING": 2
                    }
                  },
                  "transaction_details": {
                    "oneof": ["openBankingDetails"]
                  }
                }
              },
              "AsyncTransactionOpenBankingDetails": {
                "fields": {
                  "partner": {
                    "type": "squareup.esperanto.model.AsyncTransactionOpenBankingDetails.Partner",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "buyerId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "buyerAuthorizedAtMs": {
                    "type": "int64",
                    "id": 5,
                    "rule": "optional"
                  },
                  "accountFideliusToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "resourceToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "settlementRiskCategory": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Partner": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "TRUELAYER": 1
                    }
                  }
                }
              },
              "AsyncTransactionRefund": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 3,
                    "rule": "optional"
                  },
                  "failedAtMs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "refundUuid": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "refundTransactionId": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "refundRequestIdempotenceKey": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.esperanto.model.AsyncTransactionRefund.AsyncTransactionRefundStatus",
                    "id": 7,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": "squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "refundOrderId": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "refundCreationFailureReason": {
                    "type": "squareup.esperanto.create_async_transaction_refund.CreateAsyncTransactionRefundError",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "AsyncTransactionRefundStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "CREATED": 1,
                      "PENDING": 2,
                      "COMPLETED": 3,
                      "FAILED": 4
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransaction && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransaction?.nested?.AsyncTransactionStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransaction?.nested?.AsyncTransactionType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionOpenBankingDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionOpenBankingDetails?.nested?.Partner && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionRefund && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.AsyncTransactionRefund?.nested?.AsyncTransactionRefundStatus) {
  $root.addJSON(jsonData);
}

/**
 * Asynchronous Transaction.
 *
 * SOURCE AsyncTransaction @ squareup/esperanto/model/async_transaction.proto at 16:1
 */
export const AsyncTransaction = $root.lookupType('squareup.esperanto.model.AsyncTransaction');
fixType(AsyncTransaction);
Builder.createAndAttachToType(AsyncTransaction);
/**
 * SOURCE AsyncTransactionStatus @ squareup/esperanto/model/async_transaction.proto at 44:3
 */
AsyncTransaction.AsyncTransactionStatus = $root.lookupEnum('squareup.esperanto.model.AsyncTransaction.AsyncTransactionStatus').values;
/**
 * SOURCE AsyncTransactionType @ squareup/esperanto/model/async_transaction.proto at 55:3
 */
AsyncTransaction.AsyncTransactionType = $root.lookupEnum('squareup.esperanto.model.AsyncTransaction.AsyncTransactionType').values;
/**
 * Details for an Open Banking transaction.
 * This contains details provided by or generated for our 3rd-party processing partner.
 *
 * SOURCE AsyncTransactionOpenBankingDetails @ squareup/esperanto/model/async_transaction.proto at 86:1
 */
export const AsyncTransactionOpenBankingDetails = $root.lookupType('squareup.esperanto.model.AsyncTransactionOpenBankingDetails');
fixType(AsyncTransactionOpenBankingDetails);
Builder.createAndAttachToType(AsyncTransactionOpenBankingDetails);
/**
 * SOURCE Partner @ squareup/esperanto/model/async_transaction.proto at 87:3
 */
AsyncTransactionOpenBankingDetails.Partner = $root.lookupEnum('squareup.esperanto.model.AsyncTransactionOpenBankingDetails.Partner').values;
/**
 * Refund for an Asynchronous Transaction
 *
 * SOURCE AsyncTransactionRefund @ squareup/esperanto/model/async_transaction.proto at 120:1
 */
export const AsyncTransactionRefund = $root.lookupType('squareup.esperanto.model.AsyncTransactionRefund');
fixType(AsyncTransactionRefund);
Builder.createAndAttachToType(AsyncTransactionRefund);
/**
 * SOURCE AsyncTransactionRefundStatus @ squareup/esperanto/model/async_transaction.proto at 142:3
 */
AsyncTransactionRefund.AsyncTransactionRefundStatus = $root.lookupEnum('squareup.esperanto.model.AsyncTransactionRefund.AsyncTransactionRefundStatus').values;